export const studentRouter = [
  {
    path: "learning-report-pad",
    name: "learning-report-pad",
    component: () => import("@/views/learning-report-pad/learning-report-pad.vue"),
    meta: {
      title: "学习报告"
    }
  },
  {
    path: "final-report-pad",
    name: "final-report-pad",
    component: () => import("@/views/learning-report-pad/final-report-pad.vue"),
    meta: {
      title: "结课报告"
    }
  }
];
